__turbopack_context__.v({
  "blok-big-title": "Pagination-module__iSBQIG__blok-big-title",
  "blok-subtitle": "Pagination-module__iSBQIG__blok-subtitle",
  "blok-title": "Pagination-module__iSBQIG__blok-title",
  "scroll-button": "Pagination-module__iSBQIG__scroll-button",
  "wrapper": "Pagination-module__iSBQIG__wrapper",
});
